import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/themetwo/afiliado_botao_Copia.png'


const _hoisted_1 = { class: "invitation_container" }
const _hoisted_2 = { class: "menuLink_card" }
const _hoisted_3 = { class: "menuLinkContainer" }
const _hoisted_4 = { class: "card_content" }
const _hoisted_5 = { class: "menuTitle" }
const _hoisted_6 = { class: "share_title" }
const _hoisted_7 = { class: "share_list" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "sub_Container" }
const _hoisted_10 = { class: "tabel_container" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "btn_text" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "btn_text" }
const _hoisted_15 = { class: "tabel_content" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "container"
}
const _hoisted_18 = { class: "tabel_container" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "btn_text" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "btn_text" }
const _hoisted_23 = { class: "tabel_content" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 1,
  class: "container"
}
const _hoisted_26 = { class: "tabel_container" }
const _hoisted_27 = { style: {"font-weight":"bold"} }
const _hoisted_28 = { class: "tabel_content" }
const _hoisted_29 = { class: "bottom_text" }

import { computed, onMounted, ref } from 'vue';
import GraphCard from './graphCard.vue';
import { useI18n } from 'vue-i18n';
import StatusPopup from '@/components/common/statusPopup.vue';
import { getActivityInformations, getAgentInfo } from '@/api/common';
import { useActivityStore } from '@/stores/activity';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { Share } from '@capacitor/share';
import { getActivityInfoFunc, getAgentInfoDataFunc, SHARE_LIST, BettingRewards, RechargeRewards, DirectRecharge, copyHandleFunc } from '@/view/agent/supportScript'


export default /*@__PURE__*/_defineComponent({
  __name: 'invitationView',
  emits: ['closePoup'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const activityStore = useActivityStore();
const activityList = computed(() => activityStore.activityList)
const rechargeRewardList = ref<RechargeRewards[]>([])
const bettingRewardList = ref<BettingRewards[]>([])
const eachRechargeReward = ref(0)
const eachBettingReward = ref(0)
const activityIntro = ref([])
const loadingRef = ref()
const shareList = ref(SHARE_LIST)
const subTabList = ref<any>([])
const betTabList = ref<any>([])
const active = ref(0);
const activeBet = ref(0);
const directRechargeList = ref<DirectRecharge[]>([])
const selectedRechargeType = ref(0)
const activeCumulativeRecharge = ref<any>({})
const activeCumulativeBet = ref<any>({})
const teamPerformanaceList = ref<any>([])
const selectedBetType = ref(0)
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const copyUrl = ref('')
const emits = __emit
const onClickTab = (active: any) => {
    activeCumulativeRecharge.value = subTabList.value[active.name]
}
const onClickBetTab = (active: any) => {
    activeCumulativeBet.value = betTabList.value[active.name]
}
const setSelectedRechargeType = (type: number) => {
    selectedRechargeType.value = type
}
const setSelectedBetType = (type: number) => {
    selectedBetType.value = type
}
const copyHandle = () => {
    copyHandleFunc(toastContent, isSuccess, copyUrl, statusRef, t)
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const getActivityInfo = () => {
    getActivityInfoFunc(getActivityInformations, loadingRef, copyUrl, showError, emits)
}
const getAgentInfoData = () => {
    getAgentInfoDataFunc(
        getAgentInfo,
        loadingRef,
        directRechargeList,
        subTabList,
        activeCumulativeRecharge,
        bettingRewardList,
        betTabList,
        activeCumulativeBet,
        teamPerformanaceList,
        showError,
        emits
    )
}
const setData = () => {
    let agentActivity = activityList.value.find(
        (item: any) => item.name === 'agent_cash_back'
    ) || null;
    if (agentActivity) {
        let activityConfig = JSON.parse(agentActivity?.activityConfig)
        rechargeRewardList.value = activityConfig?.cumulative_recharge_config
        bettingRewardList.value = activityConfig?.cumulative_betting_config
        eachRechargeReward.value = activityConfig?.recharge_reward_percentage
        eachBettingReward.value = activityConfig?.betting_reward_percentage
        activityIntro.value = JSON.parse(agentActivity?.activityIntro)
    }

}
const goToShare = async () => {
    let shareLink = copyUrl.value //localStorage.getItem('shareLink')
    if (!shareLink) { return }
    await Share.share({
        text: shareLink,
    });
}
onMounted(() => {
    getAgentInfoData()
    getActivityInfo()
    setData()
    loadingRef.value.open()
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('common.myLink')), 1),
            _createVNode(_component_van_row, { class: "copyLink_bar" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "18",
                  class: "link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(copyUrl.value), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "6",
                  class: "copy_btn",
                  onClick: copyHandle
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "",
                      height: "40px"
                    }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('common.quickShare')), 1),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shareList.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "share_item",
                  key: item.name,
                  onClick: goToShare
                }, [
                  _createElementVNode("img", {
                    src: item.img,
                    alt: ""
                  }, null, 8, _hoisted_8),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t(item.name)), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(GraphCard),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_van_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "12",
                class: "btn_column"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "button_container",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (setSelectedRechargeType(0))),
                    style: _normalizeStyle({ opacity: selectedRechargeType.value == 1 ? '0.45' : '' })
                  }, [
                    _createElementVNode("img", {
                      src: require('@/assets/agent/quanxianzhuanyi_bai.png'),
                      alt: ""
                    }, null, 8, _hoisted_11),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('agent.directRechargeCommision')), 1)
                  ], 4)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "12",
                class: "btn_column"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "button_container",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (setSelectedRechargeType(1))),
                    style: _normalizeStyle({ opacity: selectedRechargeType.value == 0 ? '0.45' : '' })
                  }, [
                    _createElementVNode("img", {
                      src: require('@/assets/themetwo/qun_bai.png'),
                      alt: ""
                    }, null, 8, _hoisted_13),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('agent.cmultiveRechare')), 1)
                  ], 4)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_15, [
            (selectedRechargeType.value == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_van_row, { class: "tabel_hed" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, {
                        span: "10",
                        class: "head_alignemnet"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('common.level')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_col, {
                        span: "2",
                        class: "head_alignemnet"
                      }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createElementVNode("div", { class: "line" }, null, -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_van_col, {
                        span: "12",
                        class: "head_alignemnet"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('agent.giftRate')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(directRechargeList.value, (item, index) => {
                    return (_openBlock(), _createBlock(_component_van_row, {
                      class: "tabel_row",
                      key: index,
                      style: _normalizeStyle({
                            backgroundColor: index % 2 === 1 ? ' rgba(255, 255, 255, 0.04)' : 'rgba(255, 255, 255, 0.02)'
                        })
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_col, {
                          span: "11",
                          class: "head_alignemnet"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.levelName), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_van_col, {
                          span: "13",
                          class: "head_alignemnet percentage"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.value) + "%", 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["style"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (selectedRechargeType.value == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_component_van_tabs, {
                    active: active.value,
                    "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => ((active).value = $event)),
                    sticky: "",
                    ellipsis: false,
                    onClickTab: onClickTab
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subTabList.value, (item, index) => {
                        return (_openBlock(), _createBlock(_component_van_tab, {
                          key: index,
                          title: item.limit,
                          name: index
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_van_row, { class: "tabel_hed" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_van_col, {
                                  span: "10",
                                  class: "head_alignemnet"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.level')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_van_col, {
                                  span: "2",
                                  class: "head_alignemnet"
                                }, {
                                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                                    _createElementVNode("div", { class: "line" }, null, -1)
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_van_col, {
                                  span: "12",
                                  class: "head_alignemnet"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('agent.giftRate')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeCumulativeRecharge.value?.levels, (subItme, index) => {
                              return (_openBlock(), _createBlock(_component_van_row, {
                                class: "tabel_row",
                                key: index,
                                style: _normalizeStyle({
                                        backgroundColor: index % 2 === 1 ? ' rgba(255, 255, 255, 0.04)' : 'rgba(255, 255, 255, 0.02)'
                                    })
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_van_col, {
                                    span: "11",
                                    class: "head_alignemnet"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(subItme.levelName), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_van_col, {
                                    span: "13",
                                    class: "head_alignemnet percentage"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(subItme.value) + "%", 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["style"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["title", "name"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["active"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_van_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "12",
                class: "btn_column"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "button_container",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (setSelectedBetType(0))),
                    style: _normalizeStyle({ opacity: selectedBetType.value == 1 ? '0.45' : '' })
                  }, [
                    _createElementVNode("img", {
                      src: require('@/assets/agent/quanxianzhuanyi_bai.png'),
                      alt: ""
                    }, null, 8, _hoisted_19),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('agent.directBettingCommission')), 1)
                  ], 4)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "12",
                class: "btn_column"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "button_container",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (setSelectedBetType(1))),
                    style: _normalizeStyle({ opacity: selectedBetType.value == 0 ? '0.45' : '' })
                  }, [
                    _createElementVNode("img", {
                      src: require('@/assets/agent/quanxianzhuanyi_bai.png'),
                      alt: ""
                    }, null, 8, _hoisted_21),
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('agent.cumulativeBettingCommission')), 1)
                  ], 4)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_23, [
            (selectedBetType.value == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createVNode(_component_van_row, { class: "tabel_hed" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, {
                        span: "10",
                        class: "head_alignemnet"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('common.level')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_col, {
                        span: "2",
                        class: "head_alignemnet"
                      }, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createElementVNode("div", { class: "line" }, null, -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_van_col, {
                        span: "12",
                        class: "head_alignemnet"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('agent.giftRate')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bettingRewardList.value, (item, index) => {
                    return (_openBlock(), _createBlock(_component_van_row, {
                      class: "tabel_row",
                      key: index,
                      style: _normalizeStyle({
                            backgroundColor: index % 2 === 1 ? ' rgba(255, 255, 255, 0.04)' : 'rgba(255, 255, 255, 0.02)'
                        })
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_col, {
                          span: "11",
                          class: "head_alignemnet"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.levelName), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_van_col, {
                          span: "13",
                          class: "head_alignemnet percentage"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.value) + "%", 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["style"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (selectedBetType.value == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createVNode(_component_van_tabs, {
                    active: activeBet.value,
                    "onUpdate:active": _cache[5] || (_cache[5] = ($event: any) => ((activeBet).value = $event)),
                    sticky: "",
                    ellipsis: false,
                    onClickTab: onClickBetTab
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(betTabList.value, (item, index) => {
                        return (_openBlock(), _createBlock(_component_van_tab, {
                          key: index,
                          title: item.limit,
                          name: index
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_van_row, { class: "tabel_hed" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_van_col, {
                                  span: "10",
                                  class: "head_alignemnet"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.level')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_van_col, {
                                  span: "2",
                                  class: "head_alignemnet"
                                }, {
                                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                                    _createElementVNode("div", { class: "line" }, null, -1)
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_van_col, {
                                  span: "12",
                                  class: "head_alignemnet"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('agent.giftRate')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeCumulativeBet.value?.levels, (item, index) => {
                              return (_openBlock(), _createBlock(_component_van_row, {
                                class: "tabel_row",
                                key: index,
                                style: _normalizeStyle({
                                        backgroundColor: index % 2 === 1 ? ' rgba(255, 255, 255, 0.04)' : 'rgba(255, 255, 255, 0.02)'
                                    })
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_van_col, {
                                    span: "11",
                                    class: "head_alignemnet"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.levelName), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_van_col, {
                                    span: "13",
                                    class: "head_alignemnet percentage"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.value) + "%", 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["style"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["title", "name"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["active"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('agent.TeamPerformance')), 1),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_van_row, { class: "tabel_hed" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "7",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('agent.minBet')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "2",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createElementVNode("div", { class: "line" }, null, -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "6",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('agent.maxBet')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "2",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createElementVNode("div", { class: "line" }, null, -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "7",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('agent.giftRate')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamPerformanaceList.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_van_row, {
                class: "tabel_row",
                key: index,
                style: _normalizeStyle({
                        backgroundColor: index % 2 === 1 ? ' rgba(255, 255, 255, 0.04)' : 'rgba(255, 255, 255, 0.02)'
                    })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "8",
                    class: "head_alignemnet"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.min_bet), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_col, {
                    span: "8",
                    class: "head_alignemnet"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.max_bet), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_col, {
                    span: "8",
                    class: "head_alignemnet percentage"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.rate) + "%", 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["style"]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_van_row, { style: {"padding-bottom":"10px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "24",
                class: "title"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('common.activityTitle')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityIntro.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "line_text",
              key: index
            }, _toDisplayString(item), 1))
          }), 128))
        ])
      ])
    ]),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ], 64))
}
}

})